"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskCategoryDictionaryResponses = void 0;
var icd_risk_categories_1 = require("./icd-risk-categories");
var cpt_risk_categories_1 = require("./cpt-risk-categories");
var mod_risk_categories_1 = require("./mod-risk-categories");
exports.RiskCategoryDictionaryResponses = {
    IcdRowData: icd_risk_categories_1.icdRiskCategoryDictionaryResponse,
    CptRowData: cpt_risk_categories_1.cptRiskCategoryDictionaryResponse,
    ModRowData: mod_risk_categories_1.modRiskCategoryDictionaryResponse
};
//# sourceMappingURL=index.js.map